(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gloweytree-header"]) return;
  try {
    
function setupGloweyTreeCountdowns(root) {
  const timers = [...root.querySelectorAll('[data-gt-countdown]')];
  if (root.matches?.('[data-gt-countdown]')) timers.unshift(root);
  timers.forEach(timer => {
    if (timer.dataset.timerBound) return;
    timer.dataset.timerBound = 'true';
    const end = Date.parse(timer.dataset.end);
    let interval;
    const update = () => {
      const remaining = end - Date.now();
      if (!Number.isFinite(end) && timer.dataset.preview === 'true' && timer.isConnected) {
        timer.querySelectorAll('[data-time]').forEach(value => { value.textContent = '—'; });
        timer.hidden = false;
        return false;
      }
      if (!Number.isFinite(end) || remaining <= 0 || !timer.isConnected) {
        timer.hidden = true;
        if (interval) clearInterval(interval);
        return false;
      }
      const total = Math.ceil(remaining / 1000);
      const values = {days:Math.floor(total / 86400),hours:Math.floor(total / 3600) % 24,minutes:Math.floor(total / 60) % 60,seconds:total % 60};
      Object.entries(values).forEach(([unit,value]) => { timer.querySelector('[data-time="'+unit+'"]').textContent = String(value).padStart(2,'0'); });
      timer.hidden = false;
      return true;
    };
    if (update()) interval = setInterval(update,1000);
  });
}
setupGloweyTreeCountdowns(document);
document.addEventListener('shopify:section:load', event => setupGloweyTreeCountdowns(event.target));
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.gt-resources[open], .gt-mobilemenu[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.gt-resources[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  const link = event.target.closest('.gt-mobilelinks a');
  if (link) link.closest('.gt-mobilemenu').open = false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gloweytree-product"] && !Shopify.designMode) return;
  try {
    
function setupGloweyTreeProducts(root) {
  const sections = [...root.querySelectorAll('[data-gt-product]')];
  if (root.matches?.('[data-gt-product]')) sections.unshift(root);
  sections.forEach(section => {
    if (section.dataset.bound) return;
    section.dataset.bound = 'true';
    let current = section.querySelector('input[type="radio"][checked][data-price]') || section.querySelector('input[type="radio"][data-price]');
    const quantity = section.querySelector('input[name="quantity"]');
    const mainForm = section.querySelector('form');
    const addonPanel = section.querySelector('[data-gt-addon-panel]');
    const addons = [...section.querySelectorAll('[data-gt-addon]')];
    addons.forEach(addon => { addon.disabled = !(mainForm && addon.dataset.ready === 'true' && addon.dataset.inCart !== 'true'); });
    let adding = false;
    const offerTotal = (price,count) => count === 2 ? price * 2 - Math.floor(price * 0.5) : count === 3 ? price * 2 : price * count;
    const updateTotal = () => {
      const count = Math.max(1, Math.floor(Number(quantity?.value) || 1));
      if (quantity) quantity.value = count;
      const total = section.querySelector('[data-gt-order-total]');
      if (total && current) total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:section.dataset.currency || 'USD'}).format((offerTotal(Number(current.dataset.priceCents),count) + addons.filter(addon => addon.checked && !addon.disabled).reduce((sum,addon) => sum + Number(addon.dataset.priceCents),0)) / 100);
      if (current) {
        const compare = Number(current.dataset.compareCents) || 0;
        const amount = Number(current.dataset.priceCents) || 0;
        const previous = section.querySelector('[data-gt-compare]');
        const savings = section.querySelector('[data-gt-saving]');
        if (previous && savings) {
          previous.hidden = savings.hidden = !(compare > amount);
          if (compare > amount) {
            previous.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:section.dataset.currency || 'USD'}).format(compare / 100);
            savings.querySelector('[data-gt-saving-percent]').textContent = Math.round((compare - amount) / compare * 100);
          }
        }
      }
      if (current) {
        const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:section.dataset.currency || 'USD'}).format(value / 100);
        section.querySelectorAll('[data-gt-bundle-card]').forEach(card => {
          const size = Number(card.dataset.gtBundleCard);
          const price = offerTotal(Number(current.dataset.priceCents),size);
          const comparison = Number(current.dataset.compareCents) * size;
          card.querySelector('[data-gt-bundle-price]').textContent = format(price);
          const previous = card.querySelector('[data-gt-bundle-compare]');
          previous.hidden = !(comparison > price);
          previous.textContent = format(comparison);
          const active = size === count;
          card.classList.toggle('is-selected',active);
          card.querySelector('[data-gt-bundle]').checked = active;
          if (active && addonPanel) {
            const slot = card.querySelector('[data-gt-bundle-slot]');
            if (addonPanel.parentElement !== slot) slot.appendChild(addonPanel);
          }
        });
        section.querySelectorAll('.gt-option-card').forEach(card => card.classList.toggle('is-selected',card.contains(current)));
      }
      if (current) document.querySelectorAll('[data-gt-stock]').forEach(badge => {
        const reported = Number(badge.dataset.supplierCount) || 0;
        const low = (reported > 0 && reported <= Number(badge.dataset.threshold)) || Boolean(current.dataset.inventoryTracked) && current.dataset.inventoryPolicy === 'deny' && current.dataset.available === 'true' && Number(current.dataset.inventoryQuantity) > 0 && Number(current.dataset.inventoryQuantity) <= Number(badge.dataset.threshold);
        badge.hidden = !low && badge.dataset.preview !== 'true';
        const copy = badge.querySelector('[data-gt-stock-copy]');
        if (copy) copy.textContent = low ? badge.dataset.label : badge.dataset.preview === 'true' ? badge.dataset.previewLabel : '';
        const badgeLow = section.querySelector('[data-gt-badge-low]');
        if (badgeLow && section.contains(badge)) badgeLow.hidden = !low;
        const count = badge.querySelector('[data-gt-stock-count]');
        if (count) {
          count.hidden = !low;
          count.querySelector('[data-gt-stock-number]').textContent = (badge.dataset.countLabel || '').replace('__COUNT__',String(reported > 0 ? reported : current.dataset.inventoryQuantity));
        }
      });
      const upgrade = section.querySelector('[data-gt-upgrade-card]');
      if (upgrade && current) upgrade.hidden = current.hasAttribute('data-premium');
    };
    const choose = input => {
      if (!input) return;
      section.querySelectorAll('input[type="radio"][data-price]').forEach(radio => { radio.checked = radio === input; });
      current = input;
      section.querySelector('[data-gt-price]').textContent = input.dataset.price;
      const sticky = section.querySelector('[data-gt-sticky-price]');
      if (sticky) sticky.textContent = input.dataset.price;
      section.querySelectorAll('[data-gt-add]').forEach(button => {
        button.disabled = input.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.sold : button.dataset.label;
      });
      if (input.name === 'id' && location.pathname.includes('/products/')) {
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
      updateTotal();
    };
    const shiftGallery = direction => {
      const thumbs = [...section.querySelectorAll('[data-gt-thumb]')];
      if (!thumbs.length) return;
      const active = Math.max(0,thumbs.findIndex(thumb => thumb.hasAttribute('aria-current')));
      thumbs[(active + direction + thumbs.length) % thumbs.length].click();
    };
    let touchStart;
    const gallery = section.querySelector('.gt-media');
    gallery?.addEventListener('touchstart',event => { touchStart = event.changedTouches[0].clientX; },{passive:true});
    gallery?.addEventListener('touchend',event => {
      if (touchStart === undefined) return;
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 45) shiftGallery(distance < 0 ? 1 : -1);
      touchStart = undefined;
    },{passive:true});
    const reviewTrack = section.querySelector('[data-gt-review-track]');
    const reviewDots = [...section.querySelectorAll('[data-gt-review-index]')];
    reviewTrack?.addEventListener('scroll',() => {
      const slides = [...reviewTrack.querySelectorAll('[data-gt-review-slide]')];
      let nearest = 0;
      slides.forEach((slide,index) => {
        if (Math.abs(slide.offsetLeft - reviewTrack.offsetLeft - reviewTrack.scrollLeft) < Math.abs(slides[nearest].offsetLeft - reviewTrack.offsetLeft - reviewTrack.scrollLeft)) nearest = index;
      });
      reviewDots.forEach((dot,index) => dot.setAttribute('aria-pressed',String(index === nearest)));
    },{passive:true});
    section.addEventListener('click', event => {
      const reviewDot = event.target.closest('[data-gt-review-index]');
      if (reviewDot && reviewTrack) {
        const slides = reviewTrack.querySelectorAll('[data-gt-review-slide]');
        const index = Number(reviewDot.dataset.gtReviewIndex);
        slides[index]?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest',inline:'start'});
        reviewDots.forEach((dot,number) => dot.setAttribute('aria-pressed',String(number === index)));
        return;
      }
      if (event.target.closest('[data-gt-gallery-prev]')) { shiftGallery(-1); return; }
      if (event.target.closest('[data-gt-gallery-next]')) { shiftGallery(1); return; }
      if (event.target.closest('[data-gt-upgrade]')) { choose(section.querySelector('input[data-premium]')); return; }
      if (event.target.closest('[data-gt-second]')) {
        if (quantity) { quantity.value = 2; updateTotal(); quantity.focus(); }
        return;
      }
      const thumbnail = event.target.closest('[data-gt-thumb]');
      const main = section.querySelector('[data-gt-gallery-main]');
      if (thumbnail && main) {
        event.preventDefault();
        main.src = thumbnail.href;
        main.srcset = '';
        main.alt = thumbnail.querySelector('img')?.alt || '';
        section.querySelectorAll('[data-gt-thumb]').forEach(item => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      }
    });
    section.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"][data-price]')) choose(event.target);
      if (event.target.matches('[data-gt-bundle]')) {
        if (quantity) quantity.value = event.target.value;
        updateTotal();
      }
      if (event.target === quantity || event.target.matches('[data-gt-addon]')) updateTotal();
    });
    if (mainForm) mainForm.addEventListener('submit', async event => {
      const selectedAddons = addons.filter(addon => addon.checked && !addon.disabled);
      if (adding) { event.preventDefault(); return; }
      if (!selectedAddons.length) return;
      event.preventDefault();
      if (!current || current.dataset.available !== 'true') return;
      adding = true;
      const error = section.querySelector('[data-gt-cart-error]');
      if (error) error.hidden = true;
      section.querySelectorAll('[data-gt-add]').forEach(button => { button.disabled = true; });
      const rootPath = window.Shopify?.routes?.root || '/';
      try {
        const cartResponse = await fetch(rootPath+'cart.js',{headers:{'Accept':'application/json'}});
        if (!cartResponse.ok) throw new Error('Unable to check your bag. Please try again.');
        const existingCart = await cartResponse.json();
        const existingIds = new Set((existingCart.items || []).map(item => Number(item.variant_id)));
        const items = [{id:Number(current.value),quantity:Math.max(1,Math.floor(Number(quantity?.value)||1))},...selectedAddons.filter(addon => !existingIds.has(Number(addon.dataset.addonId))).map(addon => ({id:Number(addon.dataset.addonId),quantity:1}))];
        const response = await fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add these items. Please try again.');
        location.assign(rootPath+'cart');
      } catch (failure) {
        adding = false;
        if (error) { error.textContent = failure.message; error.hidden = false; }
        section.querySelectorAll('[data-gt-add]').forEach(button => { button.disabled = current.dataset.available !== 'true'; });
      }
    });
    updateTotal();
  });
}
function openGloweyTreeResourceAnchor() {
  if (location.hash !== '#gt-shipping') return;
  const disclosure = document.getElementById('gt-shipping');
  if (disclosure) disclosure.open = true;
}
openGloweyTreeResourceAnchor();
window.addEventListener('hashchange', openGloweyTreeResourceAnchor);
setupGloweyTreeProducts(document);
document.addEventListener('shopify:section:load', event => setupGloweyTreeProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
